let apiBaseUrl = window._siteProps_?.props?.apibaseurl;
let apiBaseUrl2 = window._siteProps_?.props?.apibaseurl2;
let apiBaseUrl3 = window._siteProps_?.props?.apibaseurl3;
let apiBaseUrlInternal = window._siteProps_?.props?.apiBaseUrlInternal
  ? window._siteProps_?.props?.apiBaseUrlInternal
  : "internal-s3-int-alb-51824138.ap-south-1.elb.amazonaws.com";
let imgBaseUrl = window._siteProps_?.props?.imgbaseurl;
let staticImgBaseUrl = window._siteProps_?.props?.staticimgbaseurl;
let projectBasePathWithFolder =
  window._siteProps_?.props?.projectbasepathwithfolder;
let v2PwaBasePath = window._siteProps_?.props?.v2pwabasepath;
let redirectToMapScreenAfterSeconds =
  +window._siteProps_?.props?.redirectToMapScreenAfterSeconds || 0;
let PROXY_PATH = "";
const shouldHideCompleteLoginFlow = window?._siteProps_?.props?.shouldHideCompleteLoginFlow === "true";
const shouldHideCompleteLocationFlow = window?._siteProps_?.props?.shouldHideCompleteLocationFlow === "true";
const shouldFetchLocationFromIp = window?._siteProps_?.props?.shouldFetchLocationFromIp === "true";
const oloApiEnvPath = window._siteProps_?.props?.oloApiEnvPath;
const shouldLoginFlowSkip = window?._siteProps_?.props?.shouldLoginFlowSkip === "true";
const homeMenuCategory = window?._siteProps_?.props?.homeMenuCategory || 'menuV1';
const homeGuestMenuCategory = window?._siteProps_?.props?.homeGuestMenuCategory || 'menuV1';
const themificationEnabled = window?._siteProps_?.props?.themificationEnabled === "true";
const categoriesForStrikePrice = window?._siteProps_?.props?.categoriesForStrikePrice || "";
const videoSwitch = window?._siteProps_?.props?.videoSwitch === "true";
const showIplNudgeModal = window?._siteProps_?.props?.showIplNudgeModal === "true";
const keyForEncryDecry = window?._siteProps_?.props.abstractKey;

//use on local if needed
/* apiBaseUrl = "https://s1.dominosindia.in";
apiBaseUrl2 = "https://s1.dominosindia.in";
apiBaseUrl3 = "https://s3.dominosindia.in";
staticImgBaseUrl = location.origin + "/discovery-ui-web/public/dist/default";
projectBasePathWithFolder = location.origin + "/discovery-ui-web/en/pwa";
v2PwaBasePath = "https://m.dominos.co.in";
PROXY_PATH = "http://localhost:3002/"; */

let countryCodeFromDomain;
switch (window._siteProps_?.props?.build_env_var) {
  case "production":
    if (location.host.includes("dominos.co.in")) {
      countryCodeFromDomain = "IN";
    } else if (location.host.includes("dominos.com.bd")) {
      countryCodeFromDomain = "BG";
    } else {
      countryCodeFromDomain = "SL";
    }
    break;
  case "qa":
  case "dev":
  case "local":
  default:
    countryCodeFromDomain = "IN";
}

let countryFromDomain;
switch (window._siteProps_?.props?.build_env_var) {
  case "production":
    if (location.host.includes("dominos.co.in")) {
      countryFromDomain = "INDIA";
    } else if (location.host.includes("dominos.com.bd")) {
      countryFromDomain = "BANGLADESH";
    } else {
      countryFromDomain = "SRILANKA";
    }
    break;
  case "qa":
  case "dev":
  case "local":
  default:
    countryFromDomain = "INDIA";
}

let domainReferrerFromDomain;
switch (window._siteProps_?.props?.build_env_var) {
  case "production":
    domainReferrerFromDomain = "https://" + location.host + "/";
    break;
  case "qa":
  case "dev":
  case "local":
  default:
    domainReferrerFromDomain = "https://m.dominos.co.in/";
}

const urls = {
  DOMINO_API_BASE_URL: PROXY_PATH + apiBaseUrl,
  DOMINO_API_BASE_URL2: PROXY_PATH + apiBaseUrl2,
  DOMINO_API_BASE_URL3: PROXY_PATH + apiBaseUrl3,
  DOMINO_INTERNAL_API_BASE_PATH: PROXY_PATH + apiBaseUrlInternal,
  GOOGLE_API_BASE_URL:
    PROXY_PATH + window._siteProps_?.props?.google_api_base_url,
};

const apiEndpoints = {
  REFRESH_TOKEN: urls.DOMINO_API_BASE_URL + "/loginhandler/refreshtoken",
  REFRESH_TOKEN_ANONYMOUS:
    urls.DOMINO_API_BASE_URL + "/loginhandler/refreshtokenanonymous",
  GEOCODE: urls.DOMINO_API_BASE_URL + "/locator-service/ve2/geocode",
  GOOGLE_GEO_LOCATION: urls.GOOGLE_API_BASE_URL + "/geolocation/v1/geolocate",
  LOCATOR_STORES: urls.DOMINO_API_BASE_URL + "/locator-service/ve2/stores",
  NEAREST_STORE:
    urls.DOMINO_API_BASE_URL3 + "/locator-service/ve3/nearest-store",
  LOCATOR_STORES_TAKEAWAY:
    urls.DOMINO_API_BASE_URL + "/locator-service/ve3/stores",
  STORE_OFFERS: urls.DOMINO_API_BASE_URL + "/agg/ve1/leftnav/store",
  LEFT_MENU: urls.DOMINO_API_BASE_URL + "/catalog-service/ve1/stores",
  OFFER_TNC: urls.DOMINO_API_BASE_URL + "/promo-service/ve1/promo",
  APPLY_WELCOME_OFFER: urls.DOMINO_API_BASE_URL + "/agg/cart-service/ve1/cart",
  TRACK_ORDERS: urls.DOMINO_API_BASE_URL + "/tracker-service/ve2/orders",
  USER_LOYALTY: urls.DOMINO_API_BASE_URL + "/customer-service/ve1/loyalty/user",
  REGISTER_LOYALTY: urls.DOMINO_API_BASE_URL + "/customer-service/ve1/loyalty/register",
  PERSONALIZATION_ITEMS:
    urls.DOMINO_API_BASE_URL2 +
    "/jfl-discovery-service/ve1/api/public/sites/v1/upsell-data",
  MENU_SEQUENCING:
    urls.DOMINO_API_BASE_URL2 +
    "/jfl-personalization/ve1/api/public/sites/v2/menu-data-sequence",
  WALLET_BALANCE:
    urls.DOMINO_API_BASE_URL + "/wallet-service/ve3/wallet/balance",
  ANONYMOUS_USER: urls.DOMINO_API_BASE_URL + "/loginhandler/anonymoususer",
  PIZZA_TOPPING: urls.DOMINO_API_BASE_URL + oloApiEnvPath,
  OLD_PREVIOUS_ORDER: urls.DOMINO_API_BASE_URL + "/order-service/ve1",
  PREVIOUS_ORDER: urls.DOMINO_API_BASE_URL + "/jfl-discovery-service/ue/api/public/sites/v1/store/",
  ESTIMENT_ORDER_TIME:
    urls.DOMINO_API_BASE_URL + "/order-service/ve1/orders/tracker/trackOnMap",
  SEND_TRACKER_STATUS:
    urls.DOMINO_API_BASE_URL + "/tracker-service/ve2/sendtrackerstatus",
  PAYMENT_OFFER_TNC: urls.DOMINO_API_BASE_URL3 + "/jfl-discovery-service/ve1/api/public/sites/v1/tnc",
  USER_ACTIVITY_TRACKING: urls.DOMINO_INTERNAL_API_BASE_PATH + "/user-activity-tracking/ve/v1/savePageViewData",
  PWA_CONFIG_API: urls.DOMINO_API_BASE_URL + '/api/ve1/pwa-config',
  APP_CONFIG_API: urls.DOMINO_API_BASE_URL + '/api/ve1/app-config',
  LOGIN_MINIAPP: urls.DOMINO_API_BASE_URL + '/auth-service/micro-app/ve1',
  SAVED_ADDRESS: urls.DOMINO_API_BASE_URL + '/customer-service/ve2/user',
  NPS_CSAT_HOME_WIDGET: urls.DOMINO_API_BASE_URL + '/feedback-service/ve1/feedback/widget',
  NPS_CSAT_DISMISS_HOME_WIDGET: urls.DOMINO_API_BASE_URL + '/feedback-service/ve1/feedback/widget/',
  DELETE_USER_ACCOUNT: urls.DOMINO_API_BASE_URL + '/customer-service/ve2/user/delete/generate/otp',
  CONFIRM_ACCOUNT_DELETE: urls.DOMINO_API_BASE_URL + '/customer-service/ve2/user/delete/confirm',
  SERVICE_GUARANTEE_BREAKDOWN:  urls.DOMINO_API_BASE_URL + '/locator-service/ve2/service-guarantee/breakdown',
  SPLASH_SCREEN_API: urls.DOMINO_API_BASE_URL + '/jfl-discovery-service/ve1/api/public/sites/v1/splash',
  BEST_PRICE_GUARANTEE_API: urls.DOMINO_API_BASE_URL + '/jfl-discovery-service/ve1/api/public/sites/v1/getBpgData',
};

const defaultNextgenPathname = `/jfl-discovery-ui/en/${(window?._siteProps_?.platform || "pwa").toLowerCase()}/home/6585R`;

export {
  apiEndpoints,
  imgBaseUrl,
  staticImgBaseUrl,
  projectBasePathWithFolder,
  v2PwaBasePath,
  countryCodeFromDomain,
  domainReferrerFromDomain,
  countryFromDomain,
  redirectToMapScreenAfterSeconds,
  shouldHideCompleteLoginFlow,
  shouldHideCompleteLocationFlow,
  shouldFetchLocationFromIp,
  shouldLoginFlowSkip,
  defaultNextgenPathname,
  homeMenuCategory,
  homeGuestMenuCategory,
  themificationEnabled,
  videoSwitch,
  showIplNudgeModal,
  keyForEncryDecry,
};
